'use strict';

/**
 * Returns the current session currency code.
 * @returns {string} Currency code (e.g. EUR)
 */
function getCurrency() {
    if (typeof window === 'undefined') {
        return 'EUR';
    }

    var currency =
        (window.PTDF && window.PTDF.currency) ||
        window.PTDF_CURRENCY;

    return currency || 'EUR';
}

/**
 * Parses a localized money/decimal string into a number.
 * @param {string|number|null|undefined} value - Input value
 * @returns {number} Parsed number (0 on failure)
 */
function parseDecimal(value) {
    if (value === null || value === undefined) {
        return 0;
    }

    if (typeof value === 'number' && !Number.isNaN(value)) {
        return value;
    }

    var str = String(value).trim();
    if (!str) {
        return 0;
    }

    // Keep digits, comma, dot, minus. Normalize decimal comma.
    str = str.replace(/[^\d,.-]/g, '');
    if (str.indexOf(',') > -1 && str.indexOf('.') > -1) {
        // Assume dots are thousands separators when both are present.
        str = str.replace(/\./g, '').replace(',', '.');
    } else {
        str = str.replace(',', '.');
    }

    var parsed = parseFloat(str);
    return Number.isNaN(parsed) ? 0 : parsed;
}

/**
 * Sends a GA4 event via gtag, when available.
 * @param {string} eventName - Event name
 * @param {Object} params - Event parameters
 * @returns {void}
 */
function sendEvent(eventName, params) {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
        return;
    }

    window.gtag('event', eventName, params);
}

/**
 * Extracts the first price value in the given DOM subtree.
 * @param {JQuery} $root - Root element to search within
 * @returns {number} Price value (0 if missing)
 */
function getFirstPriceValue($root) {
    if (!$root || !$root.find) {
        return 0;
    }
    var content = $root.find('.sales .value').first().attr('content');
    return parseDecimal(content);
}

module.exports = {
    getCurrency: getCurrency,
    parseDecimal: parseDecimal,
    sendEvent: sendEvent,
    getFirstPriceValue: getFirstPriceValue
};
